<template>
  <v-dialog
    :model-value="modelValue"
    width="800"
    @update:model-value="onDialogVisibility"
    @click:outside="closeModal"
  >
    <v-card rounded="lg">
      <div class="bg-red-600 relative">
        <i
          class="mdi mdi-close text-xl cursor-pointer text-white absolute top-2 right-3"
          @click="closeModal"
        ></i>
        <h2 class="text-xl font-semibold text-white py-5 pl-10">BAST IMKP</h2>
      </div>

      <div class="px-10 py-5">
        <div v-if="loading" class="py-10 text-center text-gray-500">
          Memuat data BAST…
        </div>

        <template v-else>
          <div class="mb-4">
            <p class="text-xs font-semibold text-gray-500 mb-1">Judul Proyek</p>
            <p class="text-sm font-medium text-gray-800">
              {{ judulProyek || "-" }}
            </p>
          </div>

          <div class="rounded-lg border border-gray-200 overflow-hidden mb-4">
            <div
              class="bg-red-100 text-red-700 text-sm font-semibold px-4 py-2 flex justify-between"
            >
              <span>Daftar Periksa</span>
              <span>Y</span>
            </div>
            <div
              v-for="item in penutupanArray"
              :key="item.id"
              class="flex items-center justify-between px-4 py-2 border-t border-gray-100 text-sm"
            >
              <span class="text-gray-700">{{ item.name }}</span>
              <span
                v-if="item.c_q === true"
                class="text-green-600 font-semibold"
              >
                ✓
              </span>
            </div>
          </div>

          <div v-if="fileBast.length >= 1" class="text-sm mb-4 font-medium">
            <span>File saat ini :</span>
            <ul class="mt-1">
              <li v-for="(file, index) in fileBast" :key="index">
                <a
                  class="text-red-600 font-normal cursor-pointer"
                  style="text-decoration: none"
                  @click="downloadFile(file, formatFilename)"
                >
                  File BAST_{{ index + 1 }}.pdf
                </a>
              </li>
            </ul>
          </div>

          <div class="text-sm mb-4">
            <p class="font-medium mb-1">Catatan</p>
            <v-textarea
              v-if="isEditable"
              v-model="catatan"
              variant="outlined"
              density="compact"
              color="#475569"
              rows="6"
              hide-details="auto"
              placeholder="Masukkan catatan"
            />
            <div v-else style="white-space: pre-line" class="text-gray-700">
              {{ catatan || "-" }}
            </div>
          </div>

          <div
            class="flex w-full items-center"
            :class="isEditable ? 'justify-between' : 'justify-end'"
          >
            <div v-if="isEditable" class="flex items-center gap-2">
              <input
                id="needWarranty"
                v-model="needWarranty"
                type="checkbox"
                class="cursor-pointer"
              />
              <label
                for="needWarranty"
                class="text-xs text-gray-700 cursor-pointer"
              >
                Proyek ini membutuhkan Berita Acara Serah Terima (BAST) Garansi
              </label>
            </div>

            <div class="flex justify-end gap-2">
              <FormButton
                label="Detail IMKP"
                classes="bg-blue-600 text-white capitalize"
                @click="openDetailImkp"
              />
              <template v-if="isEditable">
                <FormButton
                  v-if="!needWarranty"
                  label="Tolak"
                  classes="bg-red-600 text-white capitalize"
                  @click="needWarranty ? null : askConfirm('rejected')"
                />
                <FormButton
                  label="Setuju"
                  classes="bg-green-600 text-white capitalize"
                  @click="askConfirm('approved')"
                />
              </template>
            </div>
          </div>
        </template>
      </div>
    </v-card>
  </v-dialog>

  <ConfirmModal
    v-model="dialogConfirm"
    img="warning.png"
    title="BAST IMKP"
    :description="confirmDescription"
    wording-cancel="Batal"
    wording-confirm="Ya"
    :loading="submitting"
    @close-modal="dialogConfirm = false"
    @confirm-data="submitBast"
  />
</template>

<script>
import GlobalDataMixin from "@/GlobalDataMixin";
import FormButton from "@/components/FormButton.vue";
import ConfirmModal from "@/components/ConfirmModal.vue";
import axios from "axios";
import { API_BASE_URL, CMS_IMKP_DETAIL, CMS_SET_BAST_ADMIN } from "@/constants";
import { statusIMKPEnum } from "@/utilities/enum";
import { downloadFile } from "@/utilities/globalFunction";
import util from "@/assets/js/util";
import { cloneDeep } from "lodash";

const url_imkp_detail = API_BASE_URL + CMS_IMKP_DETAIL;
const url_imkp_bast = API_BASE_URL + CMS_SET_BAST_ADMIN;

const DEFAULT_PENUTUPAN = [
  {
    id: 1,
    name: "Apakah pekerjaan telah selesai sesuai dengan kontrak?",
    c_q: null,
  },
  {
    id: 2,
    name: "Apakah telah dilakukan pemeriksaan terkait dengan QA/QC?",
    c_q: null,
  },
];

export default {
  name: "ApprovalBastImkpModal",
  mixins: [GlobalDataMixin],
  components: {
    FormButton,
    ConfirmModal,
  },
  emits: ["update:modelValue", "submitted"],
  props: {
    modelValue: { type: Boolean, default: false },
    imkpId: { type: [Number, String], default: null },
    sioId: { type: [Number, String], default: null },
    kontraktorId: { type: [Number, String], default: null },
    status: { type: [Number, String], default: null },
    judulProyek: { type: String, default: "" },
    namaKontraktor: { type: String, default: "" },
    usecase: { type: String, default: "" },
  },
  data() {
    return {
      statusIMKPEnum,
      loading: false,
      submitting: false,
      dialogConfirm: false,
      pendingAction: null,
      penutupanArray: cloneDeep(DEFAULT_PENUTUPAN),
      fileBast: [],
      catatan: "",
      needWarranty: false,
      formatFilename: "",
    };
  },
  computed: {
    isEditable() {
      return this.status === statusIMKPEnum.BAST_PROCESS;
    },
    confirmDescription() {
      const label =
        this.pendingAction === "approved" ? "persetujuan" : "penolakan";
      return `Apakah anda yakin akan melakukan ${label} BAST IMKP ini?`;
    },
  },
  watch: {
    modelValue(open) {
      if (open) {
        this.resetForm();
        this.fetchDetail();
      } else {
        this.resetForm();
      }
    },
  },
  methods: {
    downloadFile,
    openDetailImkp() {
      window.open(`/preview-imkp/${this.imkpId}`, "_blank");
    },
    resetForm() {
      this.penutupanArray = cloneDeep(DEFAULT_PENUTUPAN);
      this.fileBast = [];
      this.catatan = "";
      this.needWarranty = false;
      this.formatFilename = "";
      this.pendingAction = null;
      this.dialogConfirm = false;
    },
    async fetchDetail() {
      if (!this.imkpId) return;
      try {
        this.loading = true;
        const result = await axios.get(url_imkp_detail, {
          params: { id: this.imkpId },
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        });
        const res = result.data.data[0];

        this.penutupanArray = cloneDeep(DEFAULT_PENUTUPAN).map((item) => ({
          ...item,
          c_q:
            item.id === 1
              ? res.penutupanIzinBekerjaQ1
              : item.id === 2
              ? res.penutupanIzinBekerjaQ2
              : null,
        }));
        this.fileBast = res.fileBast ? JSON.parse(res.fileBast) : [];
        this.formatFilename =
          "File BAST " + this.judulProyek + "-" + this.namaKontraktor;

        if (this.status === statusIMKPEnum.IMKP_DONE) {
          this.catatan = res.catatanPenutupan;
        }
      } catch (error) {
        util.showError("Terjadi kesalahan saat memuat data BAST.");
      } finally {
        this.loading = false;
      }
    },
    askConfirm(action) {
      if (this.submitting) return;
      this.pendingAction = action;
      this.dialogConfirm = true;
    },
    async submitBast() {
      try {
        this.submitting = true;
        const bodyJson = {
          id: this.imkpId,
          usecase: this.usecase,
          idSio: this.sioId,
          kontraktorId: this.kontraktorId,
          catatanPenutupan: this.catatan?.trim(),
          action: this.pendingAction,
          isNeedBastWarranty: this.needWarranty,
        };

        await axios.post(url_imkp_bast, bodyJson, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        });

        util.showInfo("BAST IMKP berhasil di tindaklanjuti!", 2000);
        this.dialogConfirm = false;
        this.$emit("submitted");
        this.closeModal();
      } catch (error) {
        util.showError("Terjadi kesalahan saat menindaklanjuti BAST IMKP!");
      } finally {
        this.submitting = false;
      }
    },
    closeModal() {
      this.onDialogVisibility(false);
    },
    onDialogVisibility(open) {
      this.$emit("update:modelValue", open);
    },
  },
};
</script>
